// Install and load fonts
import "@fontsource/ibm-plex-sans/300.css";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/700.css";
import ReactDOM from "react-dom/client";
import CssBaseline from "@mui/material/CssBaseline";
import { AuthProvider } from "react-oidc-context";
import { oidcConfig } from "shared/auth/oidc";
import "./index.css";
import App from "./features/App";

function onSigninCallback() {
  // removing the state url parameter from the URL on successful login
  window.location.href = "/";
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <AuthProvider {...oidcConfig} onSigninCallback={onSigninCallback}>
    {/* CSS reset for cross-browser design consistency */}
    <CssBaseline />
    <App />
  </AuthProvider>
);
